import React from 'react';
import Tooltip from '../../components/ui/Tooltip';
import { useCanvas } from './canvasStore';
import { MAX_ZOOM, MIN_ZOOM } from './geometry';
import { useRuntime } from './runtime';

const KEY = 'np-key np-state';

/** Filled paths on a fill-less root: the house icon construction. */
const Icon: React.FC<{ d: string }> = ({ d }) => (
  <svg aria-hidden="true" viewBox="0 0 24 24" className="h-4 w-4" fill="none">
    <path d={d} fill="currentColor" />
  </svg>
);

const PLUS = 'M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6z';
const MINUS = 'M5 11h14v2H5z';
const FIT = 'M4 4h6v2H6v4H4zM14 4h6v6h-2V6h-4zM4 14h2v4h4v2H4zM18 14h2v6h-6v-2h4z';
/** Four cards in three columns: one, two, one, the shape a fork and join tidies into. */
const TIDY = 'M2 10h5v4H2zM9.5 4h5v4h-5zM9.5 16h5v4h-5zM17 10h5v4h-5z';

/** Tidy up (managers), then zoom in, zoom out, fit: a column at the bottom right of the pane. */
const Controls: React.FC<{ onTidy?: () => void }> = ({ onTidy }) => {
  const rt = useRuntime();
  // The store's zoom is mirrored at gesture end, so the limits update when a pinch settles.
  const zoom = useCanvas((s) => s.viewport.zoom);
  return (
    <div
      data-canvas-control
      role="group"
      aria-label="Canvas controls"
      className="np-track absolute bottom-3 right-3 z-10"
    >
      {onTidy && (
        <>
          <Tooltip label="Lay the cards out in arrow order, left to right. You can keep it or undo it.">
            <button type="button" aria-label="Tidy up" onClick={onTidy} className={KEY}>
              <Icon d={TIDY} />
            </button>
          </Tooltip>
          <span aria-hidden="true" className="mx-1.5 h-px bg-outline-variant" />
        </>
      )}
      <Tooltip label="Zoom in">
        <button type="button" aria-label="Zoom in" onClick={() => rt.viewport.zoomBy(1.25)} disabled={zoom >= MAX_ZOOM - 1e-6} className={KEY}>
          <Icon d={PLUS} />
        </button>
      </Tooltip>
      <Tooltip label="Zoom out">
        <button type="button" aria-label="Zoom out" onClick={() => rt.viewport.zoomBy(0.8)} disabled={zoom <= MIN_ZOOM + 1e-6} className={KEY}>
          <Icon d={MINUS} />
        </button>
      </Tooltip>
      <Tooltip label="Fit view">
        <button type="button" aria-label="Fit view" onClick={() => rt.viewport.fitView(true)} className={KEY}>
          <Icon d={FIT} />
        </button>
      </Tooltip>
    </div>
  );
};

export default Controls;
